// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bca5e144","498":"f2e23913","703":"61618dca","787":"87fad764"}[chunkId] + ".chunk.js";
};